import {
  SOCIAL_MEDIA_DATA_FETCHED,
  SOCIAL_MEDIA_DATA_FETCHED_TOTAL,
  SOCIAL_MEDIA_DATA_LOADING,
  SOCIAL_MEDIA_DATA_ERROR,
  SOCIAL_MEDIA_DATA_STATISTICS,
  SOCIAL_MEDIA_DATA_PAGINATION
} from "../actions/index";

const initialState = {
  data: [],
  total: 0,
  loading: false,
  error: null,
  statistics: [],
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0
  }
};

const socialMediaDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SOCIAL_MEDIA_DATA_FETCHED:
      return {
        ...state,
        data: action.payload,
        error: null
      };
    case SOCIAL_MEDIA_DATA_FETCHED_TOTAL:
      return {
        ...state,
        total: action.payload
      };
    case SOCIAL_MEDIA_DATA_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case SOCIAL_MEDIA_DATA_STATISTICS:
      return {
        ...state,
        statistics: action.payload
      };
    case SOCIAL_MEDIA_DATA_PAGINATION:
      return {
        ...state,
        pagination: action.payload
      };
    case SOCIAL_MEDIA_DATA_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    default:
      return state;
  }
};

export default socialMediaDataReducer;
